import { Zilla_Slab, Noto_Sans } from 'next/font/google';

const zillaSlab = Zilla_Slab({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-zilla-slab',
  weight: ['400', '700'],
});

const notoSans = Noto_Sans({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-noto-sans',
  weight: ['400', '700'],
});

export const supportedFonts = [zillaSlab, notoSans];
